import { registerNotificationToastContext } from '@/components/layout/notification-toast/NotificationToastProvider';
import {
  NotificationToastConfig,
  NotificationToastContentSerialized,
  NotificationToastType
} from '@/types/notification-toast';
import { useDispatch } from 'react-redux';
import { ToastOptions } from 'react-toastify';
import { addNotificationToast } from '../../app/redux/features/notifications-toast';

export interface ShowNotificationToastOptions {
  id?: string;
  type?: NotificationToastType;
  title?: string;
  message?: string;
  content?: React.ReactNode | NotificationToastContentSerialized;
  config?: NotificationToastConfig;
  onClose?: () => void;
  onDismiss?: () => void;
}

export const useNotificationToast = () => {
  const dispatch = useDispatch();

  const showNotificationToast = ({
    id = Date.now().toString(),
    type = 'bare',
    title,
    message,
    content,
    config,
    onClose,
    onDismiss
  }: ShowNotificationToastOptions) => {
    let contentKey: string | undefined;

    if (content || onClose || onDismiss) {
      contentKey = `${id}-notification-toast`;
      registerNotificationToastContext(contentKey, { content, onClose, onDismiss });
    }

    dispatch(
      addNotificationToast({
        id,
        type,
        title,
        message,
        contentKey,
        config
      })
    );
  };

  return { showNotificationToast };
};
